import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation, useNavigate } from "react-router";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "../styles/contactStyles.css";
import { trackEvent } from "../utils/ga";

const Contact = () => {
  const isUAEPath = window.location.pathname.startsWith("/uae");
  const currentLocation = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const initialValues = {
    name: "",
    email: "",
    mobile: "",
    location: "",
    message: "",
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email"),
    mobile: Yup.string()
      .matches(/^[0-9]+$/, "Must be a number")
      .min(7, "Too short")
      .max(15, "Too long")
      .required("Mobile is required"),
    // location: Yup.string().required("Location is required"),
    // message: Yup.string().trim().required("Message is required"),
  });

  const handleSubmit = async (values) => {
    trackEvent("Form", "Submit", "Contact Form");
    setLoading(true);

    try {
      const response = await fetch(
        "https://api.mytimewatch.com/api/contact/contact",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(values),
        }
      );
      const result = await response.text();
      console.log("result", result);
      navigate("/thank-you");
    } catch (error) {
      console.error("Submission Error:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container my-5">
      <div className="form p-2 p-md-0">
        <div className="row">
          <div className="col-md-6">
            <h2 className="text-danger mb-4 mt-2 fw-bold">
              Get in Touch with Us!
            </h2>

            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
            >
              <Form>
                {["name", "mobile", "email", "location"].map((field) => (
                  <div className="form-group mb-3" key={field}>
                    <label
                      htmlFor={field}
                      className="fw-bold mb-1"
                      style={{ fontSize: "18px" }}
                    >
                     
                      {field.charAt(0).toUpperCase() + field.slice(1)}
                      {
                        ["name", "mobile"].includes(field) && (<span style={{ color: "#f14144" }}>*</span>)
                      } 
                    
                    </label>
                    <Field
                      id={field}
                      name={field}
                      placeholder={`Enter your ${field}`}
                      className="form-control"
                      style={{
                        border: "2px solid grey",
                        borderRadius: "50px",
                      }}
                    />
                    <div className="text-danger">
                      <ErrorMessage name={field} />
                    </div>
                  </div>
                ))}

                <div className="form-group mb-3">
                  <label
                    htmlFor="message"
                    className="fw-bold mb-1"
                    style={{ fontSize: "18px" }}
                  >
                    Message
                    {/* <span style={{ color: "#f14144" }}>*</span> */}
                  </label>
                  <Field
                    as="textarea"
                    id="message"
                    name="message"
                    rows="4"
                    placeholder="Write to us"
                    className="form-control"
                    style={{
                      border: "2px solid grey",
                      borderRadius: "5px",
                    }}
                  />
                  <div className="text-danger">
                    <ErrorMessage name="message" />
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn btn-danger btn-block fw-bold"
                  disabled={loading}
                >
                  {loading ? "Submitting..." : "Get in Touch"}
                </button>
              </Form>
            </Formik>
          </div>

          <div className="col-md-6 d-none d-md-flex justify-content-center align-items-center">
            <img
              src={
                isUAEPath
                  ? "https://timewatch.co.in/images/DubaiMap.png"
                  : "https://timewatch.co.in/images/OurPresence.png"
              }
              alt="Location Map"
              className="img-fluid rounded"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
